import { tzOffset } from '../../helpers/date-time';
import { LangEnum, LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { CustomCacheRequest } from '../../types/props';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

const baseUrl = `${managerApiUrl}/dashboard`;

export type DashboardType =
  | 'orders_by_category'
  | 'top_10_dishes'
  | 'popular_dishes'
  | 'delayed_tasks'
  | 'menu_heat_map'
  | 'total_tasks_in_time'
  | 'orders_by_employee'
  | 'total_tasks_by_category_in_time'
  | 'plan_fact_task_time'
  | 'tasks_by_employee'
  | 'frequent_tasks'
  | 'tasks_peaks'
  | 'tasks_daily_load'
  | 'tasks_by_rating'
  | 'most_loaded_qrs'
  | 'tasks_by_status'
  | 'feedback_average_rating'
  | 'feedbacks_by_category'
  | 'qrs_with_positive_feedbacks'
  | 'qrs_with_negative_feedbacks'
  | 'feedbacks_by_time'
  | 'feedbacks_by_qr'
  | 'ignored_tasks'
  | 'total_work_time'
  | 'overtime_percent'
  | 'top_late_employees'
  | 'top_overtime_employees'
  | 'overtime_heat_map'
  | 'deviation_balance'
  | 'qr_stats';

export type FetchDashboardDataRequest = {
  dashboards: DashboardType[];
  from?: string;
  to?: string;
  branch?: string;
  extra_filters?: {
    section_ids?: string[];
    ignore_time_over_than?: number;
  };
  language?: LangEnum;
} & CustomCacheRequest;

export const fetchDashboardData = async (
  params: FetchDashboardDataRequest,
): Promise<Record<DashboardType, unknown>> => {
  const response = await baseFetch(baseUrl + buildParams({ ...params, offset: -tzOffset }));
  return response?.data;
};

export type DashboardCardType = 'menu' | 'qr';

export type DashboardCardDataType = {
  scans: number;
  devices: number;
  reviews: number;
  tasks: number;

  orders: number;

  waiter: LangType;
};

export type FetchDashboardCardsRequest = Pick<
  Omit<FetchDashboardDataRequest, 'dashboards'>,
  'from' | 'to' | 'branch'
> & {
  type: DashboardCardType;
};

export const fetchDashboardCards = async (
  params: FetchDashboardCardsRequest,
): Promise<DashboardCardDataType> => {
  const response = await baseFetch(
    baseUrl + '/cards' + buildParams({ ...params, offset: -tzOffset, cards: true }),
  );
  return response?.data;
};
